import { useInfiniteQuery } from 'react-query';
import InAppNotificationsApi, {
  InAppNotificationsQueryParams,
} from 'app/api/inAppNotifications';
import { queryKey } from 'constants/queryKey';
import { ApiClientError } from 'api/client';
import { InAppNotification } from 'types/InAppNotification';

export const NOTIFICATIONS_PAGE_SIZE = 12;

function uniqueById(pages: InAppNotification[][]): InAppNotification[] {
  const seen = new Set<string>();

  return pages.flat().filter(({ id }) => {
    if (seen.has(id)) {
      return false;
    }

    seen.add(id);
    return true;
  });
}

const useInAppNotificationsQuery = (params: InAppNotificationsQueryParams) => {
  const query = useInfiniteQuery<InAppNotification[], ApiClientError>(
    queryKey.inAppNotifications(params),
    ({ pageParam = 1 }) =>
      InAppNotificationsApi.get({ ...params, page: pageParam }),
    {
      getNextPageParam: (lastPage, allPages) =>
        lastPage.length < NOTIFICATIONS_PAGE_SIZE
          ? undefined
          : allPages.length + 1,
    },
  );

  return {
    ...query,
    notifications: uniqueById(query.data?.pages ?? []),
  };
};

export default useInAppNotificationsQuery;
